import { Field, IconButton, Modal, Text, TextInput } from "@carbon6/c6-frontend-design";
import type { ChangeEvent, ReactNode, SyntheticEvent } from "react";
import { hatcheryTextModes } from "@/app/theme";
import { HatModalHeader } from "@/components/modal";
import type { LabelDialogState } from "../LabelPageTypes";
import styles from "../LabelPage.module.css";
import { LabelDetailsFields } from "./LabelDetailsFields";

type LabelCreateDialogProps = {
  dialog: Extract<LabelDialogState, { kind: "create" }>;
  onClose: () => void;
  onColorChange: (color: number) => void;
  onDescriptionChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onKeyChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (event: SyntheticEvent<HTMLFormElement, SubmitEvent>) => void;
  onValueChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

export function LabelCreateDialog({
  dialog,
  onClose,
  onColorChange,
  onDescriptionChange,
  onKeyChange,
  onSubmit,
  onValueChange,
}: LabelCreateDialogProps): ReactNode {
  return (
    <Modal
      open
      onClose={onClose}
      size="md"
      closeOnBackdropClick={!dialog.submitting}
      closeOnEscape={!dialog.submitting}
      aria-labelledby="label-create-dialog-title"
    >
      <HatModalHeader
        title="새 라벨을 만듭니다."
        titleId="label-create-dialog-title"
        close={{ disabled: dialog.submitting }}
      />
      <form className={styles.dialogForm} onSubmit={onSubmit}>
        <Text variant={hatcheryTextModes["caption-bold"]} className={styles.dialogEyebrow}>
          라벨 카탈로그
        </Text>
        <div className={styles.fields}>
          <Field label="키" layout="stack" disabled={dialog.submitting}>
            <TextInput value={dialog.form.key} maxLength={32} required onChange={onKeyChange} />
          </Field>
          <Field label="값" layout="stack" disabled={dialog.submitting}>
            <TextInput value={dialog.form.value} maxLength={64} required onChange={onValueChange} />
          </Field>
          <LabelDetailsFields
            color={dialog.form.color}
            colorFieldId="label-create-color"
            description={dialog.form.description}
            disabled={dialog.submitting}
            onColorChange={onColorChange}
            onDescriptionChange={onDescriptionChange}
          />
        </div>
        {dialog.errorMessage ? (
          <Text
            variant={hatcheryTextModes["body-normal"]}
            className={styles.dialogError}
            role="alert"
          >
            {dialog.errorMessage}
          </Text>
        ) : null}
        <div className={styles.dialogActions}>
          <IconButton
            text="취소"
            type="button"
            variant="surface"
            disabled={dialog.submitting}
            onClick={onClose}
          />
          <IconButton
            text={dialog.submitting ? "생성 중" : "생성"}
            type="submit"
            variant="solid"
            disabled={dialog.submitting}
          />
        </div>
      </form>
    </Modal>
  );
}
